import Fonction from './fonction'

export class VariableContexte {
  nom
  type
  reference
  referenceObj = null
  tags
  description
  fonction

  constructor(nom = '', type = null, reference = null, tags = [], description = '', fonction = new Fonction()) {
    this.nom = nom
    this.type = type
    this.reference = reference
    this.tags = tags
    this.description = description
    this.fonction = fonction
  }

  static NULL = new VariableContexte()
}
